"use strict";

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var cov_55gbbyq51 = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/repositories/Repositories.js";
  var hash = "022477002aecff0b13b2ab73a9e4d544b2e2e8ff";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/repositories/Repositories.js",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 27
        },
        end: {
          line: 25,
          column: 3
        }
      },
      "1": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 23,
          column: 5
        }
      },
      "2": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 28
        }
      },
      "3": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 82
        }
      },
      "4": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 25
        }
      },
      "5": {
        start: {
          line: 27,
          column: 19
        },
        end: {
          line: 27,
          column: 21
        }
      },
      "6": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 46,
          column: 3
        }
      },
      "7": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 36,
          column: 6
        }
      },
      "8": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 35,
          column: 8
        }
      },
      "9": {
        start: {
          line: 37,
          column: 9
        },
        end: {
          line: 46,
          column: 3
        }
      },
      "10": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 45,
          column: 6
        }
      },
      "11": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 44,
          column: 8
        }
      },
      "12": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 51,
          column: 4
        }
      },
      "13": {
        start: {
          line: 54,
          column: 0
        },
        end: {
          line: 66,
          column: 2
        }
      },
      "14": {
        start: {
          line: 68,
          column: 15
        },
        end: {
          line: 71,
          column: 1
        }
      },
      "15": {
        start: {
          line: 73,
          column: 28
        },
        end: {
          line: 73,
          column: 69
        }
      }
    },
    fnMap: {
      "0": {
        name: "RepositoriesComponent",
        decl: {
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 30
          }
        },
        loc: {
          start: {
            line: 17,
            column: 3
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 27
          },
          end: {
            line: 18,
            column: 28
          }
        },
        loc: {
          start: {
            line: 18,
            column: 38
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 29,
            column: 34
          },
          end: {
            line: 29,
            column: 35
          }
        },
        loc: {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 35,
            column: 8
          }
        },
        line: 30
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 38,
            column: 26
          },
          end: {
            line: 38,
            column: 27
          }
        },
        loc: {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 44,
            column: 8
          }
        },
        line: 39
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }, {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }],
        line: 20
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        }, {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 46,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 46,
            column: 3
          }
        }, {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 46,
            column: 3
          }
        }],
        line: 37
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "022477002aecff0b13b2ab73a9e4d544b2e2e8ff"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Repositories = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _ = require("../");

var _helpers = require("../repository/helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function RepositoriesComponent(_ref) {
  var classes = _ref.classes,
      urls = _ref.urls,
      repositories = _ref.repositories,
      onRepository = _ref.onRepository,
      config = _ref.config;
  cov_55gbbyq51.f[0]++;
  cov_55gbbyq51.s[0]++;

  var updateRepository = function updateRepository(_repo) {
    cov_55gbbyq51.f[1]++;

    var __repo;

    cov_55gbbyq51.s[1]++;

    if (_repo) {
      cov_55gbbyq51.b[0][0]++;
      cov_55gbbyq51.s[2]++;
      __repo = _objectSpread({}, _repo);
      cov_55gbbyq51.s[3]++;
      __repo = (0, _helpers.extendRepository)({
        repository: __repo,
        updateRepository: updateRepository,
        config: config
      });
    } else {
      cov_55gbbyq51.b[0][1]++;
    }

    cov_55gbbyq51.s[4]++;
    onRepository(__repo);
  };

  var components = (cov_55gbbyq51.s[5]++, []);
  cov_55gbbyq51.s[6]++;

  if (repositories) {
    cov_55gbbyq51.b[1][0]++;
    cov_55gbbyq51.s[7]++;
    components = repositories.map(function (repository) {
      cov_55gbbyq51.f[2]++;
      cov_55gbbyq51.s[8]++;
      return _react.default.createElement(_.Repository, {
        key: JSON.stringify(repository),
        repository: repository,
        onRepository: updateRepository,
        config: config
      });
    });
  } else {
    cov_55gbbyq51.b[1][1]++;
    cov_55gbbyq51.s[9]++;

    if (urls) {
      cov_55gbbyq51.b[2][0]++;
      cov_55gbbyq51.s[10]++;
      components = urls.map(function (url, index) {
        cov_55gbbyq51.f[3]++;
        cov_55gbbyq51.s[11]++;
        return _react.default.createElement(_.Repository, {
          key: index,
          url: url,
          onRepository: updateRepository,
          config: config
        });
      });
    } else {
      cov_55gbbyq51.b[2][1]++;
    }
  }

  cov_55gbbyq51.s[12]++;
  return _react.default.createElement(_core.List, {
    className: classes.root
  }, components);
}

cov_55gbbyq51.s[13]++;
RepositoriesComponent.propTypes = {
  classes: _propTypes.default.object.isRequired,

  /** Urls array to get repository data, if repository data is not provided. */
  urls: _propTypes.default.array,

  /** Repositories data array to render, if urls not provided. */
  repositories: _propTypes.default.array,

  /** Function to call when repository is selected. */
  onRepository: _propTypes.default.func.isRequired,

  /** Configuration required if paths are provided as URL. */
  config: _propTypes.default.shape({
    server: _propTypes.default.string.isRequired
  })
};
var styles = (cov_55gbbyq51.s[14]++, {
  root: {}
});
var Repositories = (cov_55gbbyq51.s[15]++, (0, _styles.withStyles)(styles)(RepositoriesComponent));
exports.Repositories = Repositories;